<div class="text-end mb-2">
  <button type="button"
          class="btn btn-sm btn-outline-danger"
          [disabled]="!schedules.length"
          (click)="requestClearSchedules($event)">
    <i class="fa fa-trash"></i> Clear All Schedules
  </button>
</div>

<table class="schedule-table">
  <thead>
    <tr>
      <th width="12.5%">Time</th>
      <th width="12.5%" *ngFor="let day of days">{{ day }}</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let hour of hours">
      <td class="time-label">{{ hour }}:00</td>
      <ng-container *ngFor="let day of days">
        <ng-container *ngIf="getScheduleForCell(day, hour) as schedule">
          <td *ngIf="hour === schedule.startHour"
              class="time-slot"
              [class.selected]="isCellInSelection(day, hour)"
              [class.schedule-border]="isCellScheduleBorder(day, hour)"
              [attr.rowspan]="schedule.endHour - schedule.startHour + 1"
              (click)="cellClicked(day, hour, $event)">
            <div class="schedule-content" [class.editing]="schedule.editing">
              <div *ngIf="schedule.editing" class="resize-handle resize-handle-top" (mousedown)="startResize(schedule, 'top', $event)"></div>
              <ng-container *ngIf="!schedule.editing" (click)="schedule.editing = true; $event.stopPropagation()">
                <b>Autonomous</b>
                Cutoff:
                <br/>
                <larger>{{schedule.cutoff}}</larger>
              </ng-container>
              <ng-container *ngIf="schedule.editing">
                <b>Autonomous</b>
                <label>Cutoff:</label>
                <br/>
                <input class="form-control mt-2" type="number" min="0" max="100" [(ngModel)]="schedule.cutoff" />
                <br/>
                <button class="btn btn-xs btn-success mr-2" (click)="saveSchedule(schedule); $event.stopPropagation()"><i class="fa fa-check"></i></button>
                <button class="btn btn-xs btn-default mr-2" (click)="cancelEdit(schedule); $event.stopPropagation()"><i class="fa fa-close"></i></button>
                <br/>
                <button class="btn btn-xs btn-danger mr-2" (click)="deleteSchedule(schedule); $event.stopPropagation()"><i class="fa fa-trash"></i></button>
                <button class="btn btn-xs btn-primary mr-2" (click)="copySchedule(schedule); $event.stopPropagation()"><i class="fa fa-copy"></i></button>
              </ng-container>
              <div *ngIf="schedule.editing" class="resize-handle resize-handle-bottom" (mousedown)="startResize(schedule, 'bottom', $event)"></div>
            </div>
          </td>
        </ng-container>
        <td *ngIf="!getScheduleForCell(day, hour) && !isCellCoveredByRowspan(day, hour)"
            class="time-slot"
            [class.selected]="isCellInSelection(day, hour)"
            (click)="cellClicked(day, hour, $event)">
        </td>
      </ng-container>
    </tr>
  </tbody>
</table>